// extracted by mini-css-extract-plugin
export default {"closeButton":"DrawerTooltipContainer_closeButton__mXC3J"};